import { useState } from 'react';

export enum FallbackMethod {
	FAST = 'fast',
	CHEAP = 'cheap'
}

export const useFallback = ({ initialMethod, initialEnabled }) => {
	const [fallbackMethod, setFallbackMethod] = useState(initialMethod);
	const [isFallbackMethodEnabled, setIsFallbackMethodEnabled] = useState(initialEnabled);

	return { fallbackMethod, setFallbackMethod, isFallbackMethodEnabled, setIsFallbackMethodEnabled };
};
